export const GET_USER_STATISTIC_REQUEST = 'GET_USER_STATISTIC_REQUEST';
export const GET_USER_STATISTIC_SUCCESS = 'GET_USER_STATISTIC_SUCCESS';
export const GET_USER_STATISTIC_ERROR = 'GET_USER_STATISTIC_ERROR';
